/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import {loginUser} from '@/http/requests/auth'
import {hideLoading} from '@/assets/js/functions'
import { getAssetsUrl } from '@/prototypes/u/other'

export default {
  loginUser ({commit}, payload) {
    return new Promise((resolve, reject) => {
      loginUser(payload.user).then((response) => {
        // if (!response.data.user.avatar) response.data.user.avatar = 'https://app.useral.com/api/user-avatar.jpg'
        // else response.data.user.avatar = `https://app.useral.com/api/${  response.data.user.avatar}`
        // console.log(response)
        localStorage.setItem('user', JSON.stringify(response.data.user))
        // Set accessToken
        commit('SET_ACCESS_TOKEN', {token: response.data.token, expired_at: response.data.expired_at})

        // Update User Info
        commit('UPDATE_USER_INFO', response.data.user)

        // Set bearer token in axios
        commit('SET_BEARER', response.data.token)

        // Set User Browser Settings
        // commit('table/SET_USER_BROWSER_SETTING', JSON.parse(response.data.user.browser_setting) || {}, {root: true})

        // Close animation if passed as payload
        setTimeout(() => {
          if (payload.closeAnimation) payload.closeAnimation()
        }, 1500)

        resolve(response)
        // payload.notify({
        //   time: 2500,
        //   title: i18n('login.notification.login.title'),
        //   text: i18n('login.notification.login.message'),
        //   iconPack: 'feather',
        //   icon: 'icon-log-in',
        //   color: 'success'
        // })
      }).catch((error) => {

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        payload.notify({
          time: 2500,
          title: 'خطا',
          text: error.response && error.response.data ? error.response.data.message : error.response.data,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        reject(error)
      })
    })
  },

  updateUserInfo ({commit}, user) {
    if (user.avatar) {
      user.smallAvatar = getAssetsUrl(user.avatar, 'h100,w100', user.route)
      user.avatar = getAssetsUrl(user.avatar, '', user.route)
    }

    delete user.route

    commit('UPDATE_USER_INFO', user)
  },

  setAccessToken ({commit}) {
    commit('SET_BEARER', localStorage.getItem('accessToken'))
  },

  logout ({commit}) {
    commit('REMOVE_USER_INFO')
    commit('REMOVE_ACCESS_TOKEN')
    location.reload()
    hideLoading()
  }
}
